<template>
  <div
    v-if="config.visible"
  >
    <v-row
      class="main-row"
    >
<!--      Time of registration-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/aggregator.registration_time') }}:
        </div>

        <div
          class="value"
        >
          12.05.2025. 09:45
        </div>
      </v-col>

<!--      Source of registration-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/aggregator.source_of_registration') }}:
        </div>

        <div
          class="value"
        >
          Work order
        </div>
      </v-col>

<!--      Company-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('base.company') }}:
        </div>

        <div
          class="value"
        >
          ZG ceste / PRP
        </div>
      </v-col>

<!--      Entered-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/aggregator.entered') }}:
        </div>

        <div
          class="value"
        >
          Marko markovic
        </div>
      </v-col>

<!--      Type of registration-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/aggregator.type_of_registration') }}:
        </div>

        <div
          class="value"
        >
          Setting up the regulation
        </div>
      </v-col>

<!--      Address-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/patrol-service.address') }}:
        </div>

        <div
          class="value"
          style="padding-left: 0;"
        >
          Ulica platana 1, 10 000, Zagreb
        </div>
      </v-col>

<!--      Duration-->
      <v-col
        class="info-col"
      >
        <div
          class="title"
        >
          {{ $t('road-maintenance/aggregator.duration') }}:
        </div>

        <div
          class="value"
        >
          14.05.2025., 10:00 to 15.05.2025., 10:00
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InformationAboutRoute',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
    }
  },

  methods: {
  }
}
</script>

<style scoped lang="scss">
.title {
  font-family: 'Satoshi', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #6B7280 !important;
  margin-bottom: 4px;
}

.value {
  font-family: 'Satoshi', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #111827 !important;
}

.info-col {
  min-width: fit-content;
  padding: 0 14px;
  flex-grow: unset !important;
}

.info-col:first-child {
  padding-left: 0;
}

.info-col:last-child {
  padding-right: 0;
}

.info-col:not(:last-child) {
  border-right: 1px solid #E5E7EB;
}

.main-row {
  padding: 24px;
  margin: 0 24px;
  border-radius: 16px;
  border: 1px solid #E5E7EB;
  background-color: #F9FAFB;
}
</style>
